import { invoiceAllIcon, invoiceIcon, invoiceWithoutOrderIcon } from 'assets';

// --- Dynamically build the invoice navigation item ---
export const buildInvoiceNav = (organisationType) => {
  const agencyTypeId = 2;
  return organisationType === agencyTypeId
    ? {
        id: 6,
        title: 'Invoices',
        collapsible: true,
        icon: invoiceIcon,
        subLinks: [
          {
            id: 1,
            subTitle: 'All Invoices',
            path: '/invoices',
            icon: invoiceAllIcon,
          },
          {
            id: 2,
            subTitle: 'Without Order',
            path: '/invoices/without-order',
            icon: invoiceWithoutOrderIcon,
          },
        ],
      }
    : {
        id: 6,
        title: 'Invoices',
        path: '/invoices',
        icon: invoiceIcon,
      };
};
